import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../client.model';
import { ClientService } from '../client.service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { sortBy, get, lowerCase, map, chain, unescape } from 'lodash';
import { AppRoutingService } from '../../app-routing.service';
import { Encoder } from '../../../utils/encoder';

@Component({
  selector: 'app-client-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ClientListComponent implements OnInit {

  alerts: any = {
    newClientAdded: {
      show: false,
      type: 'success',
      msg: 'Client registered successfully'
    },
    error: {
      show: false,
      type: 'danger',
      msg: 'An error occurred'
    }
  };

  showAlert: boolean;

  clientList: Array<Client>;

  private previousUrl: string;

  constructor(private router: Router, private route: ActivatedRoute,
    private clientService: ClientService, private routingService: AppRoutingService) {

    this.clientList = new Array<Client>();
    this.showAlert = false;
  }

  ngOnInit() {
    this.alerts.newClientAdded.show = this.clientService.hasJustRegistered;
    this.getClientList();
  }

  onClosed(dismissedAlert: any): void {
    dismissedAlert.show = false;
  }

  private getClientList(): void {

    const data = this.route.snapshot.data;

    this.clientList = get(data, ['clients'], []);
    // Applying decode and unescape on string fields. Sorting by name
    this.clientList = chain(this.clientList)
      .map(item => {
        item.clientId = Encoder.decode(item.clientId);
        item.providerId = Encoder.decode(item.providerId);
        item.campaignId = Encoder.decode(item.campaignId);
        return item;
      })
      .sortBy((item) => lowerCase(item.clientId)).value();

    if (this.clientList.length === 0) {
      this.showAlert = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/client/list/list.component.ts